/**
 * Labstep
 *
 * @module components/ProtocolDevice/Action/Create
 * @desc Create a protocolDevice
 */

import { CanCreate } from 'labstep-web/components/Entity/Can';
import { EntityCreateContainer } from 'labstep-web/containers/Entity/Create';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import { SearchSelectContainer as SearchSelect } from 'labstep-web/core/Select/Search';
import { Device } from 'labstep-web/models/device.model';
import { Protocol } from 'labstep-web/models/protocol.model';
import { ProtocolDevice } from 'labstep-web/models/protocol-device.model';
import type React from 'react';
import type {
  IProtocolDeviceActionCreateContainerProps,
  IProtocolDeviceActionCreateProps,
} from './types';

export const ProtocolDeviceActionCreate: React.FC<
  IProtocolDeviceActionCreateProps
> = ({ parent, create, options, modalProps }) => (
  <Modal
    usePortal
    header="Add Device"
    viewComponent={
      <ActionComponent
        dataCy="components/ProtocolDevice/Action/Create"
        type="button"
        text="Add Device"
      />
    }
    content={({ toggleModal }) => (
      <SearchSelect
        autoFocus
        openMenuOnFocus
        creatable
        entityName={Device.entityName}
        value={null}
        onChange={(option) => {
          create(
            {
              [`${
                parent instanceof Protocol ? 'protocol' : 'experiment'
              }_id`]: parent.id,
              device_id: option.id,
            },
            options,
          );
          toggleModal();
        }}
        usePartialSerializer
      />
    )}
    {...modalProps}
  />
);

export const ProtocolDeviceActionCreateContainer: React.FC<
  IProtocolDeviceActionCreateContainerProps
> = (props) => (
  <CanCreate
    parentName={props.parent.entityName}
    parentId={props.parent.id}
    entityName="protocol_device"
  >
    <EntityCreateContainer entityName={ProtocolDevice.entityName}>
      {({ create, status }) => (
        <ProtocolDeviceActionCreate
          create={create}
          status={status}
          {...props}
        />
      )}
    </EntityCreateContainer>
  </CanCreate>
);
